import React from "react";
import { FaMedal } from "react-icons/fa";

import SystematicRepechageMatchCard from "./SystematicRepechageMatchCard";

const BronzeBoard = ({
  bronzeA,
  bronzeB,
  onOpenCreate,
  onOpenEdit,
  onOpenScoreboard,
}) => {
  return (
    <div className="border-t border-slate-200 bg-gradient-to-br from-amber-50 via-white to-orange-50 p-5 dark:border-white/10 dark:from-amber-500/10 dark:via-slate-950 dark:to-orange-500/10">
      <div className="mb-5">
        <div className="inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-100 dark:ring-amber-400/30">
          <FaMedal />
          Places de 3e
        </div>

        <h3 className="mt-3 text-xl font-bold text-slate-900 dark:text-white">
          Combats pour les médailles de bronze
        </h3>

        <p className="mt-1 max-w-5xl text-sm text-slate-500 dark:text-slate-400">
          Les gagnants des tableaux de repêchage rencontrent les perdants des
          demi-finales. Les deux vainqueurs sont classés 3e.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
        <div className="rounded-[1.75rem] border border-amber-200 bg-white p-4 shadow-[0_14px_40px_rgba(245,158,11,0.10)] dark:border-amber-400/25 dark:bg-slate-950">
          <h4 className="mb-3 text-sm font-bold uppercase tracking-[0.14em] text-amber-700 dark:text-amber-100">
            Combat 3e place A
          </h4>

          <SystematicRepechageMatchCard
            match={bronzeA}
            onOpenCreate={onOpenCreate}
            onOpenEdit={onOpenEdit}
            onOpenScoreboard={onOpenScoreboard}
          />
        </div>

        <div className="rounded-[1.75rem] border border-amber-200 bg-white p-4 shadow-[0_14px_40px_rgba(245,158,11,0.10)] dark:border-amber-400/25 dark:bg-slate-950">
          <h4 className="mb-3 text-sm font-bold uppercase tracking-[0.14em] text-amber-700 dark:text-amber-100">
            Combat 3e place B
          </h4>

          <SystematicRepechageMatchCard
            match={bronzeB}
            onOpenCreate={onOpenCreate}
            onOpenEdit={onOpenEdit}
            onOpenScoreboard={onOpenScoreboard}
          />
        </div>
      </div>
    </div>
  );
};

export default BronzeBoard;